import { render, staticRenderFns } from "./CompleteProfile.vue?vue&type=template&id=37d57e6f&scoped=true&"
import script from "./CompleteProfile.vue?vue&type=script&lang=js&"
export * from "./CompleteProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompleteProfile.vue?vue&type=style&index=0&id=37d57e6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d57e6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
